import React, { useContext, useEffect, useState } from "react";
import Menu from "../settings-menu/Menu";
import { UserContext } from "../../data/betslip/UserConf";

window.xs_toggleSettings = function() {
    window.dispatchEvent(new CustomEvent('xs_toggleSettings'));
}

export default function SettingsToggle() {
    const userContext = useContext(UserContext);
    const [toggled, setToggled] = useState(false);

    function toggle() {
        if (!toggled === false) {
            const settings = window.getSettingsToSaveOnDB();
            if (settings != null) {
                userContext.saveSportFrontendConfiguration(settings);
            }
        }
        setToggled(prev => !prev);
    }

    useEffect(() => {
        window.addEventListener('xs_toggleSettings', toggle);

        return () => window.removeEventListener('xs_toggleSettings', toggle);
    }, []);

    
    return (
        <>
            {toggled &&
                <Menu toggle={toggle} />
            }
        </>
    );
}
